var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    width: "100%",
    height: "100%",
    viewBox: "0 0 523.65 505.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87c5ad",
    d: "M558.11,311.06,396.32,537a30.11,30.11,0,0,1-10.77,9.19L196.34,281.92,41.58,65.72a14.06,14.06,0,0,1,11.63-22H372.77a28.92,28.92,0,0,1,23.55,12.06L558.11,281.92a25.25,25.25,0,0,1,0,29.14",
    transform: "translate(-39.09 -43.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#619179",
    d: "M372.77,549.24H53.22A14.13,14.13,0,0,1,41.71,527l99.51-138.91Z",
    transform: "translate(-39.09 -43.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a715c",
    d: "M385.53,546.20a27.35,27.35,0,0,1-12.77,3L141.22,388.05l55.14-77a25.36,25.36,0,0,0,.13-29Z",
    transform: "translate(-39.09 -43.75)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9504f2f063159818680e6112befbbd3.svg";
export { ForwardRef as ReactComponent };